const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { formatData } from '@/constants/commonContent';

export default function shareholdersPdfMaker(shareholders, getMember, owners) {
  const title = shareholders.titleText;
  function memberSign(name) {
    return { text: 'Signature: ' + name, alignment: 'right', italics: true };
  }
  function setTotalValue(field, value) {
    let number = parseFloat(value.replace(/,/g, ''));
    totalValue[field] += number;
  }
  let totalValue = {
    holding: 0,
    percent: 0
  };
  let tableBody: any[] = [];
  const tableHeader = shareholders.columns.map(column => {
    return { text: column.title, style: 'tableHeader' };
  });
  tableBody.push(tableHeader);
  const tableRows = shareholders.rows.map(row => {
    let tableRow: any[] = [];
    shareholders.columns.map(column => {
      if (['holding', 'percent'].includes(column.field))
        setTotalValue(column.field, row[column.field]);
      if (column.field === 'id') {
        tableRow.push(row[column.field] + 1);
      } else {
        tableRow.push(row[column.field]);
      }
    });
    return tableRow;
  });
  tableBody.push(...tableRows);
  const tableFooter = [
    { text: '', border: [true, true, false, true] },
    { text: '', border: [false, true, false, true] },
    { text: '', border: [false, true, false, true] },
    formatData.number(totalValue.holding),
    totalValue.percent.toFixed(2) + '%'
  ];
  tableBody.push(tableFooter);
  const signRow2: any[] = [];
  for (let addr in owners) {
    signRow2.push([{ text: '\n' }, { text: '\n' }, { text: '\n' }, { text: '\n' }]);
    const footerRow = [
      {},
      { text: 'Director: ' + getMember(addr).name, alignment: 'right' },
      { text: '', alignment: 'right' },
      memberSign(getMember(addr).name)
    ];
    signRow2.push(footerRow);
  }
  const dd = {
    content: [
      {
        text: title,
        style: 'header',
        margin: [130, 0, 0, 25],
        fontSize: 22
      },
      {
        table: {
          widths: ['auto', '*', '*', '20%', 'auto'],
          headerRows: 1,
          body: tableBody
        }
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: signRow2,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false,
        margin: [0, 50, 0, 0]
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'justify'
      },
      tableExample: {
        margin: [0, 5, 0, 5]
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: 'black'
      }
    }
  };
  return pdfMake.createPdf(dd);
}
